// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"67":"d93696ea","78":"09f2f90b","132":"0080bbbc","282":"26a41232","283":"1fad4598","323":"ecdf1159","333":"4d1ce110","354":"7bb6e4e8","415":"93d561d1","444":"ec16d98e","502":"19929555","592":"f2d3246b","694":"3d90bff2","794":"f02a59a5","888":"7f4170d3"}[chunkId] + ".js";
};